import { defineStore } from "pinia";
import { useI18nStore } from "./i18nStore";

interface ContactInfo {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
    phone_country?: string | null;
    company?: string | null;
}

export const useContactInfoStore = defineStore("contactInfoStore", {
    state: () => ({
        contactInfo: {
            name: null,
            email: null,
            phone: null,
            phone_country: useI18nStore().country,
            company: null,
        } as ContactInfo,
    }),
    getters: {
        getContactInfo(): ContactInfo {
            return this.contactInfo;
        },
    },
    actions: {
        setContactInfo({ name, email, phone, phone_country, company }: ContactInfo) {
            this.contactInfo = { name, email, phone, phone_country, company };
        },
    },
});
